import React, { useEffect, useState, useCallback } from "react";
import adminService from "../../../../services/adminService";
import "./AdminAttributions.scss";

export default function AdminAttributions() {
    const [attributions, setAttributions] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const [selected, setSelected] = useState(null);
    const [freelancers, setFreelancers] = useState([]);
    const [loadingFreelancers, setLoadingFreelancers] = useState(false);

    const loadAttributions = useCallback(async (term) => {
        setLoading(true);
        try {
            const data = await adminService.getAttributions(term || undefined);
            setAttributions(data);
        } catch (err) {
            console.error("Erro ao carregar atribuições:", err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadAttributions();
    }, [loadAttributions]);

    useEffect(() => {
        const timeout = setTimeout(() => loadAttributions(search), 300);
        return () => clearTimeout(timeout);
    }, [search, loadAttributions]);

    const handleSelect = async (name) => {
        setSelected(name);
        setLoadingFreelancers(true);
        try {
            const data = await adminService.getAttributionFreelancers(name);
            setFreelancers(data);
        } catch (err) {
            console.error("Erro ao carregar freelancers da atribuição:", err);
        } finally {
            setLoadingFreelancers(false);
        }
    };

    return (
        <div className="admin-attributions">
            <div className="admin-attributions__header">
                <h3>Atribuições Profissionais</h3>
                <input
                    type="text"
                    placeholder="Buscar atribuição (ex: garçom, barman)..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="admin-attributions__search"
                />
            </div>

            <div className="admin-attributions__body">
                <div className="admin-attributions__list">
                    {loading && (
                        <div className="admin-empty-state">Carregando...</div>
                    )}
                    {!loading && attributions.length === 0 && (
                        <div className="admin-empty-state">Nenhuma atribuição encontrada.</div>
                    )}
                    {attributions.map((attr) => (
                        <div
                            key={attr.name}
                            className={`admin-attributions__card ${
                                selected === attr.name ? "admin-attributions__card--active" : ""
                            }`}
                            onClick={() => handleSelect(attr.name)}
                        >
                            <span className="admin-attributions__card-name">{attr.name}</span>
                            <span className="admin-attributions__card-count">{attr.count}</span>
                        </div>
                    ))}
                </div>

                <div className="admin-attributions__detail">
                    {!selected && (
                        <div className="admin-empty-state">
                            Selecione uma atribuição para ver os freelancers.
                        </div>
                    )}
                    {selected && (
                        <>
                            <div className="admin-attributions__detail-title">
                                {selected} — {freelancers.length} freelancer(s)
                            </div>
                            {loadingFreelancers && (
                                <div className="admin-empty-state">Carregando...</div>
                            )}
                            {!loadingFreelancers && freelancers.map((f) => (
                                <div className="admin-attributions__freelancer" key={f.id}>
                                    <div className="admin-attributions__freelancer-avatar">
                                        {f.avatarUrl
                                            ? <img src={f.avatarUrl} alt={f.name} />
                                            : f.name?.[0]}
                                    </div>
                                    <div className="admin-attributions__freelancer-info">
                                        <strong>{f.name}</strong>
                                        {f.isGold && <span className="admin-attributions__badge-gold">Gold</span>}
                                        <div className="admin-attributions__freelancer-meta">
                                            {f.cidade && f.estado ? `${f.cidade} - ${f.estado}` : "Local não informado"}
                                        </div>
                                        <div className="admin-attributions__freelancer-contact">
                                            {f.email} {f.phone ? `• ${f.phone}` : ""}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {!loadingFreelancers && freelancers.length === 0 && (
                                <div className="admin-empty-state">
                                    Nenhum freelancer com essa atribuição.
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}